import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as data from 'src/assets/data.json';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  @Input() patientId:any;
  public findings: Array<any> = [];
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    let record = data.data.find(x => x.info.Id == this.patientId)!!.scores
    this.findings = Object.keys(record)
  }

}
